import React from "react";
import {CreateBackupContainer} from "./CreateBackupContainer";

export const CreateBackupScreen = (): React.ReactElement => {

    return <CreateBackupContainer/>;
}